import { Select } from "antd";
import PropTypes from "prop-types";
import { useState } from "react";

import { getIntValue } from "@/utilities/number";

import { CHOICE_SHAPE } from "./ModalChoices.constant";
import ModalScrollableChoices from "./ModalScrollableChoices";

import "./ModalChoices.style.less";

const ModalChoices = ({
  choices = [],
  value = "",
  onChange = () => {},
  ...rest
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Select
        {...rest}
        value={getIntValue(value)} // placeholder only appears when value is undefined
        styles={{ popup: { root: { display: "none" } } }} // we only want the dropdown "input like" look & feel
        onOpenChange={() => setIsModalOpen(true)}
        onClear={() => onChange(undefined)}
        allowClear={true}
        options={choices.map(({ name, value }) => ({
          label: name,
          value: getIntValue(value),
        }))}
      />

      {isModalOpen && (
        <ModalScrollableChoices
          value={value}
          choices={choices}
          onChange={onChange}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

ModalChoices.propTypes = {
  choices: PropTypes.arrayOf(CHOICE_SHAPE),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ModalChoices;
